import { Controller } from "@hotwired/stimulus";

// Reveals [data-reveal] elements as they enter the viewport.
// Elements are only hidden once .reveals-enabled lands on <html>, so the
// page stays fully visible without JavaScript.
export default class extends Controller {
  connect() {
    document.documentElement.classList.add("reveals-enabled");
    this.items = Array.from(this.element.querySelectorAll("[data-reveal]"));

    if (!("IntersectionObserver" in window)) {
      this.items.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -36px" },
    );

    this.items.forEach((item) => {
      if (item.classList.contains("is-visible")) return;

      if (item.getBoundingClientRect().top < window.innerHeight) {
        // Already on screen (hero): double rAF so the entrance still animates.
        requestAnimationFrame(() =>
          requestAnimationFrame(() => item.classList.add("is-visible")),
        );
      } else {
        this.observer.observe(item);
      }
    });
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }
}
